import React, { useEffect } from "react";

const Adstwo = () => {
  useEffect(() => {
    // Ensure adsbygoogle is initialized
    try {
      if (window.adsbygoogle && Array.isArray(window.adsbygoogle)) {
        window.adsbygoogle.push({});
      }
    } catch (e) {
      console.error("Adsense error", e);
    }
  }, []);

  return (
    <>
      {/* Evventoz - Side Bar Vertical ad */}
      <div style={{ margin: "20px 0", textAlign: "center" }}>
        <ins
          className="adsbygoogle"
          style={{ display: "block" }}
          data-ad-client="ca-pub-1874554549734336"
          data-ad-slot="8462838559"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
    </>
  );
};

export default Adstwo;
